import { FC } from 'react'
import { UseFormReturn } from 'react-hook-form'

import { Send, ShieldCheck, UserPlus } from 'lucide-react'
import SelectWithRadio from 'components/form/SelectWithRadio'
import { GroupFormType } from '../GroupForm/utils'
import { JoinModeOptions } from '@wellesley/forms'

const joinModeSelect = [
  {
    key: JoinModeOptions.anyone,
    description: `No approval needed – anyone can join the group immediately`,
    icon: <UserPlus />,
  },
  {
    key: JoinModeOptions.request,
    description: `User request should be approved by a group admin or moderator`,
    icon: <ShieldCheck />,
  },
  {
    key: JoinModeOptions.invite,
    description: `Only users with an invitation from member can join`,
    icon: <Send />,
  },
]

type CmpProps = {
  form: UseFormReturn<GroupFormType>
  title: string
  disabled?: boolean
  className?: string
}

const JoinModeSelect: FC<CmpProps> = ({ form, title, disabled, className }) => {
  return (
    <SelectWithRadio
      form={form}
      name="joinMode"
      title={title}
      options={joinModeSelect}
      disabled={disabled}
      className={className}
    />
  )
}

export default JoinModeSelect
